import { useState } from "react";
import ShimmerLoader from "./ShimmerLoader";
import { formatAmount } from "../Utils/helper";

const NavLinks = (props) => {
    // console.log(props.ischangeRequested);

    const [pos, setpos] = useState(0)
    const { loading } = props
    function handleTabClick(pos) {
        setpos(pos)
        props.menuClick(props.MenuLinks[pos])
    }
    return (
        <div className='navItemContainer'>
            {props.MenuLinks.map((i, index) => {
                return (
                    <div className={pos === index && !loading ? 'navItemSelected' : 'navItem'} key={index} onClick={() => handleTabClick(index)}>
                        {loading ? <ShimmerLoader width='7rem' height='2rem' /> :
                            <div className='navLinkText'> <span to={i.link} className='navLink'>{i.name}</span > {i.subText ? <span>({formatAmount(i.subText)})</span> : null} </div>}
                    </div>
                )
            })}
        </div>
    )
}
export default NavLinks;